import MultiImageGallery from './MultiImageGallery'
import SingleImageGallery from './SingleImageGallery'

const exports = {
  MultiImageGallery,
  SingleImageGallery,
}

export default exports
